"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIZES = void 0;
const SIZES = exports.SIZES = {
  S: {
    iconSize: 16,
    backgroundSize: 28
  },
  M: {
    iconSize: 24,
    backgroundSize: 36
  },
  L: {
    iconSize: 32,
    backgroundSize: 44
  }
};